<template>
  <div class="ma-4 px-4">
    <v-sheet outlined>
      <v-data-table
        :headers="courseHeaders"
        :items="sectionCourse"
        fixed-header
        :items-per-page="5"
        hide-default-footer
        :single-expand="true"
        class="secondary row-height-50"
      >
        <template #[`item.department_id`]="{ item }">
          {{ item.department_id ? getDepartment(item) : "-" }}
        </template>
        <template #[`item.active`]="{ item }">
          <v-chip
            small
            :color="item.active ? 'green' : 'red'"
            dark
            @click="openConfirm(item)"
          >
            {{ showActiveStatus(item) }}
          </v-chip>
        </template>
        <template #[`item.objectives`]="{ item }">
          <v-chip
            small
            @click="showData(item.name, item.objectives, 'Objective')"
          >
            View</v-chip
          >
        </template>
        <template #[`item.outcomes`]="{ item }">
          <v-chip small @click="showData(item.name, item.outcomes, 'Outcome')">
            View</v-chip
          >
        </template>
        <template #[`item.experiments`]="{ item }">
          <div>
            <v-chip
              v-if="item.experiments && item.experiments.length"
              small
              @click="showData(item.name, item.experiments, 'Experiment')"
            >
              View
            </v-chip>
            <span v-else>-</span>
          </div>
        </template>
        <template #[`item.action`]="{ item }">
          <v-icon small class="mr-2" color="accent" @click="editCourse(item)">
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </v-sheet>
    <div class="pt-6">
      <span class="text-5xl font-weight-bold accent--text"> DETAIL </span>
    </div>
    <searchBarFilter
      @add="(courseDetaildialog = true), (editDetailMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
      class="mt-0"
      :disable-add="courseDetails.length === 1"
    />
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="filteredDetailsHeaders"
            :search="search"
            :items="courseDetails"
            :custom-filter="customFilter"
            fixed-header
            :items-per-page="5"
            hide-default-footer
            class="secondary row-height-50"
          >
            <template #[`item.objectives`]="{ item }">
              <v-chip
                small
                @click="showData(item.name, item.objectives, 'Objective')"
              >
                View</v-chip
              >
            </template>
            <template #[`item.outcomes`]="{ item }">
              <v-chip
                small
                @click="showData(item.name, item.outcomes, 'Outcome')"
              >
                View</v-chip
              >
            </template>
            <template #[`item.experiments`]="{ item }">
              <div>
                <v-chip
                  v-if="item.experiments && item.experiments.length"
                  small
                  @click="showData(item.name, item.experiments, 'Experiment')"
                >
                  View
                </v-chip>
                <span v-else>-</span>
              </div>
            </template>
            <template #[`item.description`]="{ item }">
              <v-chip
                small
                @click="showData(item.name, item.description, 'Description')"
              >
                View</v-chip
              >
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item)"
              >
                {{ showActiveStatus(item) }}
              </v-chip>
            </template>

            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="editCourseDetail(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template v-if="sections.length > 5" v-slot:footer>
              <div class="d-flex text--accent justify-end mx-3 pa-3">
                <span
                  @click="navigateUnits()"
                  style="
                    cursor: pointer;
                    color: #4f4584;
                    text-decoration: underline;
                  "
                  >View More</span
                >
              </div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <div class="pt-6" v-if="showUnitsAndVideos">
      <span class="text-5xl font-weight-bold accent--text"> UNITS </span>
    </div>
    <searchBar
      v-if="showUnitsAndVideos"
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
      class="mt-0"
    />

    <v-row v-if="showUnitsAndVideos">
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="sections"
            :custom-filter="customFilter"
            fixed-header
            :items-per-page="5"
            hide-default-footer
            class="secondary row-height-50"
          >
            <template #[`item.course_id`]="{ item }">
              {{ getCourse(item) }}
            </template>
            <template #[`item.description`]="{ item }">
              <v-chip
                small
                @click="showData(item.name, item.description, 'Description')"
              >
                View</v-chip
              >
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item)"
              >
                {{ showActiveStatus(item) }}
              </v-chip>
            </template>

            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template v-if="sections.length > 5" v-slot:footer>
              <div class="d-flex text--accent justify-end mx-3 pa-3">
                <span
                  @click="navigateUnits()"
                  style="
                    cursor: pointer;
                    color: #4f4584;
                    text-decoration: underline;
                  "
                  >View More</span
                >
              </div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <div class="pt-6" v-if="showUnitsAndVideos">
      <span class="text-5xl font-weight-bold accent--text">
        VIDEO COURSES
      </span>
    </div>
    <searchBar
      v-if="showUnitsAndVideos"
      @add="(videoCourseDialog = true), (editVideoCourseMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
      class="mt-0"
    />

    <v-row v-if="showUnitsAndVideos">
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="courseVideoHeaders"
            :search="search"
            :items="videoCourses"
            :custom-filter="customFilter"
            fixed-header
            :items-per-page="5"
            hide-default-footer
            class="secondary row-height-50"
          >
            <template #[`item.course_id`]="{ item }">
              {{ getCourse(item) }}
            </template>
            <template #[`item.url`]="{ value }">
              <a :href="value" target="_blank"> {{ value }}</a>
            </template>
            <template #[`item.action`]="{ item }">
              <v-icon
                small
                class="mr-2"
                color="accent"
                @click="editVideoCourse(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <template v-if="sections.length > 5" v-slot:footer>
              <div class="d-flex text--accent justify-end mx-3 pa-3">
                <span
                  @click="navigateVideoCourses()"
                  style="
                    cursor: pointer;
                    color: #4f4584;
                    text-decoration: underline;
                  "
                  >View More</span
                >
              </div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="courseDialog" width="800" persistent scrollable>
      <courseDialog
        v-if="courseDialog"
        @closeDialog="courseDialog = false"
        @update="updateCourse"
        :course="course"
        :departments="departments"
        :edit="editCourseMode"
      />
    </v-dialog>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createSection"
        @update="updateSection"
        :section="section"
        :courses="courses"
        :course_id="Number(course_id)"
        :edit="editMode"
      />
    </v-dialog>
    <v-dialog v-model="videoCourseDialog" width="800" persistent scrollable>
      <videoDialog
        v-if="videoCourseDialog"
        @closeDialog="videoCourseDialog = false"
        @create="createVideoCourse"
        @update="updateVideoCourse"
        :video_course="video_course"
        :courses="courses"
        :course_id="Number(course_id)"
        :edit="editVideoCourseMode"
      />
    </v-dialog>
    <v-dialog v-model="courseDetaildialog" width="800" persistent scrollable>
      <detailDialog
        v-if="courseDetaildialog"
        @closeDialog="courseDetaildialog = false"
        @create="createDetailCourse"
        @update="updateDetailCourse"
        :course_detail="course_detail"
        :sub_type="sectionCourse[0].sub_type"
        :courses="courses"
        :course_id="Number(course_id)"
        :edit="editDetailMode"
      />
    </v-dialog>
    <v-dialog v-model="showDialog" max-width="600" persistent scrollable>
      <v-card class="secondary">
        <v-card-title class="primary white--text"
          >{{ selectedItem.name }} - {{ selectedItem.content_name }}
          <v-spacer></v-spacer>
          <v-btn small icon @click="showDialog = false">
            <v-icon small color="secondary">mdi-close</v-icon>
          </v-btn></v-card-title
        >
        <v-divider></v-divider>
        <v-card-text class="mt-3 reset-card-text">
          <div v-html="selectedItem.description"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDataDialog" max-width="600" persistent scrollable>
      <v-card class="secondary">
        <v-card-title class="primary white--text"
          >{{ selectedItem.content_name }}
          <v-spacer></v-spacer>
          <v-btn small icon @click="showDataDialog = false">
            <v-icon small color="secondary">mdi-close</v-icon>
          </v-btn></v-card-title
        >
        <v-divider></v-divider>
        <v-card-text class="mt-3 reset-card-text">
          <div v-html="selectedItem.description"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import courseDialog from "@/components/course/form.vue";
import formDialog from "@/components/course/units.vue";
import videoDialog from "@/components/course/videos.vue";
import detailDialog from "@/components/course/details.vue";
import searchBar from "@/components/searchBar.vue";
import searchBarFilter from "@/components/searchBarFilter.vue";
import {
  courseHeaders,
  courseUnitHeaders,
  courseVideoHeaders,
  courseDetailHeaders,
} from "@/constants/headers";
export default {
  components: {
    formDialog,
    courseDialog,
    videoDialog,
    detailDialog,
    searchBar,
    searchBarFilter,
  },
  data() {
    return {
      viewMode: "table",
      headers: courseUnitHeaders,
      courseHeaders: courseHeaders,
      courseVideoHeaders: courseVideoHeaders,
      detailsHeaders: courseDetailHeaders,
      dialog: false,
      courseDialog: false,
      videoCourseDialog: false,
      editMode: false,
      deleteDialog: false,
      search: "",
      sectionCourse: [],
      sections: [],
      courses: [],
      videoCourses: [],
      courseDetails: [],
      departments: [],
      section: {},
      coure: {},
      video_course: {},
      course_detail: {},
      course_id: null,
      showDialog: false,
      selectedItem: {},
      courseDetaildialog: false,
      editDetailMode: false,
      showUnitsAndVideos: false,
      showDataDialog: false,
    };
  },
  watch: {},
  computed: {
    filteredDetailsHeaders() {
    if (!this.detailsHeaders) return [];

    if (this.sectionCourse?.[0]?.sub_type === "Theory") {
      return this.detailsHeaders.filter(
        h => !String(h.text || "").toLowerCase().includes("experiment")
      );
    }
    return this.detailsHeaders;
  }
  },
  created() {
    this.course_id = this.$route.query.id;
    this.course_name = this.$route.query.name;
    this.$store.commit("setBreadcrumbs", [
      { text: "Courses", to: { name: "Courses" } },
      { text: this.course_name },
    ]);
    this.initialise();
  },
  methods: {
    async initialise() {
      const [sections, courseDetails, courses, departments, videoCourses] =
        await Promise.all([
          this.$axios.get("course_sections"),
          this.$axios.get("course_details_by_course_id/" + this.course_id),
          this.$axios.get("courses"),
          this.$axios.get("departments"),
          this.$axios.get("course_videos"),
        ]);

      const data = sections.data.data;
      this.sections = data
        .filter((s) => s.course_id == this.course_id)
        .sort((a, b) => b.id - a.id);
      this.courses = courses.data.data;
      this.departments = departments.data.data;
      const videoCourseData = videoCourses.data.data;
      this.videoCourses = videoCourseData.filter((s) => {
        return s.course_id == this.course_id;
      });
      this.courseDetails = courseDetails.data.data;
      this.sectionCourse = this.courses.filter(
        (s) => s.id == Number(this.course_id)
      );
    },
    async createSection(data) {
      await this.$axios
        .post("course_sections", { course_section: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Course Unit created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateSection(data) {
      await this.$axios
        .put("course_sections/" + data.id, { course_section: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Course Unit updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateCourse(data) {
      await this.$axios
        .put("courses/" + data.id, { course: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Course updated successfully",
            color: "success",
          });
          this.resetCourseValue();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },

    editCourse(item) {
      this.course = { ...item };
      this.editCourseMode = true;
      this.courseDialog = true;
    },
    resetCourseValue() {
      this.editCourseMode = false;
      this.courseDialog = false;
      this.course = {};
    },

    async createVideoCourse(data) {
      await this.$axios
        .post("course_videos", { course_video: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Video Course created successfully",
            color: "success",
          });
          this.resetVideoCourseValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateVideoCourse(data) {
      await this.$axios
        .put("course_videos/" + data.id, { course_video: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Video Course updated successfully",
            color: "success",
          });
          this.resetVideoCourseValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async createDetailCourse(data) {
      await this.$axios
        .post("course_details", { course_detail: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Course detail created successfully",
            color: "success",
          });
          this.resetCourseDetailValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateDetailCourse(data) {
      await this.$axios
        .put("course_details/" + data.id, { course_detail: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Course detail updated successfully",
            color: "success",
          });
          this.resetCourseDetailValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },

    editVideoCourse(item) {
      this.video_course = { ...item };
      this.editVideoCourseMode = true;
      this.videoCourseDialog = true;
    },
    resetVideoCourseValues() {
      this.editDetailMode = false;
      this.videoCourseDialog = false;
      this.video_course = {};
    },

    editCourseDetail(item) {
      this.course_detail = { ...item };
      this.editDetailMode = true;
      this.courseDetaildialog = true;
    },
    resetCourseDetailValues() {
      this.editVideoCourseMode = false;
      this.courseDetaildialog = false;
      this.course_detail = {};
    },
    edit(item) {
      this.section = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.deleteDialog = false;
      this.section = {};
    },
    getCourse(item) {
      return this.courses.find((x) => x.id == item.course_id)?.name;
    },
    showActiveStatus(value) {
      return value ? "Active" : "Inactive";
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const course = this.getCourse(item);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        course.toLowerCase().includes(search.toLowerCase())
      );
    },
    getDepartment(item) {
      return this.departments.find((x) => x.id == item.department_id)?.name;
    },
    showData(name, content, content_name) {
      this.showDialog = true;
      this.selectedItem.description = content;
      this.selectedItem.name = name;
      this.selectedItem.content_name = content_name;
    },
    navigateUnits() {
      this.$router.push({
        path: `/course_units`,
        query: {
          id: this.course_id,
          name: this.course_name,
        },
      });
    },
    navigateVideoCourses() {
      this.$router.push({
        path: `/video_courses`,
        query: {
          id: this.course_id,
          name: this.course_name,
        },
      });
    },
    showData(name, content, content_name) {
      this.showDataDialog = true;
      this.selectedItem.description = content;
      this.selectedItem.name = name;
      this.selectedItem.content_name = content_name;
    },
  },
};
</script>

<style></style>
